module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 6h-6V2c0-1.106-.894-2-2-2H10C8.894 0 8 .894 8 2v4H2C.894 6 0 6.894 0 8v22c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V8c0-1.106-.894-2-2-2zM12 4h8v2h-8V4zm16 24H4v-8h4v2c0 1.106.894 2 2 2s2-.894 2-2v-2h8v2c0 1.106.894 2 2 2s2-.894 2-2v-2h4v8z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/briefcase-1.js
// module id = 1024
// module chunks = 14